import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22c64ea0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }

import { ref } from "vue";
import EventsServices from "../../services/EventsServices";
import { EventShopOrderStatusOptions } from "@/core/types/shop/ShopPointsTypes";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetail',
  setup(__props, { expose: __expose }) {

const { t } = i18n.global;
const showDialog = ref(false);
const isLoading = ref(false);
const title = ref("");
const data = ref(<any>[]);
const show = (item: any) => {
  showDialog.value = true;
  title.value = t("fields.orderDetail") + " " + item.id;
  fecthData(item);
};

const fecthData = async (item: any) => {
  isLoading.value = true;
  try {
    const res = await EventsServices.queryOrderDetail(item.id);
    data.value = res;
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};
const getLabel = (value: number) => {
  const option = EventShopOrderStatusOptions.value.find(
    (option) => option.value === value
  );
  return option ? option.label : "";
};
__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_ShopPoints = _resolveComponent("ShopPoints")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
    title: title.value,
    width: "1200",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_descriptions, {
        class: "margin-top",
        column: 3,
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.orderNumber')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(data.value.id), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.itemName')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(data.value.eventShopItemName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.status')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabel(data.value.status)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.quantity')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(data.value.quantity), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.points')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ShopPoints, {
                points: data.value.totalPoint
              }, null, 8, ["points"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.date')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TimeShow, {
                "date-iso-string": data.value.createdOn,
                type: "customCSS"
              }, null, 8, ["date-iso-string"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions, {
        class: "mt-5",
        border: "",
        title: _ctx.$t('title.userDetails'),
        direction: "vertical"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.name')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(data.value.eventPartyNativeName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.email')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(data.value.eventPartyEmail), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_el_descriptions, {
        class: "mt-5",
        title: _ctx.$t('fields.shippingAddress'),
        column: 2,
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.name')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(data.value.address?.name), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.phone')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(data.value.address?.ccc) + " " + _toDisplayString(data.value.address?.phone), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.address')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(data.value.address?.content.address), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.city')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(data.value.address?.content.city), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.state')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(data.value.address?.content.state), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.country')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(data.value.address?.country), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          (data.value.content?.socialMediaType)
            ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                key: 0,
                label: _ctx.$t('fields.secondaryContact')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("fields." + data.value.content?.socialMediaType)) + ": " + _toDisplayString(data.value.content?.socialMediaAccount), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title"]),
      (data.value.comment != '')
        ? (_openBlock(), _createBlock(_component_el_descriptions, {
            key: 0,
            class: "mt-5",
            border: "",
            direction: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, {
                label: _ctx.$t('fields.comment')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(data.value.comment), 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_descriptions, {
        class: "my-5",
        border: "",
        column: 2,
        title: _ctx.$t('fields.trackingInformation')
      }, {
        default: _withCtx(() => [
          (data.value.shipping?.trackingNumber)
            ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                key: 0,
                label: _ctx.$t('fields.trackingNumber')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(data.value.shipping?.trackingNumber), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : (_openBlock(), _createBlock(_component_el_descriptions_item, {
                key: 1,
                label: _ctx.$t('fields.trackingNumber')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("fields.waitingForShippment")), 1)
                ]),
                _: 1
              }, 8, ["label"]))
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})